"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedGuestNotification =
/*#__PURE__*/
function (_pb_1$GuestNotificati) {
  _inherits(ExtendedGuestNotification, _pb_1$GuestNotificati);

  function ExtendedGuestNotification(properties) {
    var _this;

    _classCallCheck(this, ExtendedGuestNotification);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedGuestNotification).call(this, properties));
    _this.type = ExtendedGuestNotification.type;
    return _this;
  }

  _createClass(ExtendedGuestNotification, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.guest).concat(ExtendedGuestNotification.context);
      var mqttMessage = new paho_mqtt_1.Message(pb_1.GuestNotification.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedGuestNotification(pb_1.GuestNotification.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedGuestNotification;
}(pb_1.GuestNotification);

ExtendedGuestNotification.type = "GuestNotification";
ExtendedGuestNotification.context = "/notification";
exports.GuestNotification = ExtendedGuestNotification;